import { createFileRoute } from "@tanstack/react-router";
import { ConnectorsAdminPage } from "@/shared/ui/ConnectorsAdminPage";

export const Route = createFileRoute("/_app/connectors")({
  component: ConnectorsAdminPage,
});
